import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { Toast } from '../helpers';
import { fetchWrapper } from '../helpers/fetch-wrapper';
import appConfig from '../config';

// create slice

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        token: null,
        user: null,
        isAuth: null,
        error: null,
        categories: null,
    }
}

function createReducers(state) {
    return {
        logout: () => {
            state.token = null;
            state.error = null;
            state.user = null;
            state.isAuth = false;
        },
        setUser: (state, {payload}) => {
            state.user = payload;
        },
        setToken: (state, {payload}) => {
            state.token = payload;
        },
        setIsAuth: (state, {payload}) => {
            state.isAuth = payload;
        },
    };


    // function logout(state) {
    //     state.token = null;
    //     state.error = null;
    //     state.categories = null;
    //     state.user = null;
    //     state.isAuth = false;
    // }
}

function createExtraActions() {
    const baseUrl = `${appConfig.apiUrl}`;


    return {
        login: login(),
        set_categories: setCategories(),
    };

    function login() {
        return createAsyncThunk(
            `${name}/signin`,
            async ({ email, password, ip, device, fingerprint }) => await fetchWrapper.post(`${baseUrl}/login`, { email, password, ip, device, fingerprint })
        );
    }

    function setCategories() {
        return createAsyncThunk(
            `${name}/set/categories`,
            ({ categories }) => {
                return categories;
            }
        );
    }

}

function createExtraReducers() {
    return (builder) => {
        login();
        setCategories();

        function login() {
            var { pending, fulfilled, rejected } = extraActions.login;
            builder
                .addCase(pending, (state) => {
                    state.error = null;
                })
                .addCase(fulfilled, (state, action) => {
                    const data = action.payload.data;

                    sessionStorage.setItem('init-btn', 0);
                    setTimeout(() => {
                        sessionStorage.removeItem('init-btn');
                        // window.location.reload();
                    }, 1800);

                    if (data.userdevice.length !== 0 && data.userdevice.filter(device => device.id === data.current_device.id).length === 1) {
                        Toast('success', "Successfully Logged in", 'tr', false, false, false, 3800, false);

                        state.token = data.token;
                        state.user = data.user

                        setTimeout(() => {
                            // history.navigate('/');
                            window.location.href = '/';
                        }, 3000);

                    } else {
                        Toast('info', data.message, 'tr', false, false, false, 3800, false);

                        sessionStorage.setItem('token', JSON.stringify(data.token));
                        sessionStorage.setItem('deviceId', data.current_device);
                        sessionStorage.setItem('message', data.message);
                        // console.log('device is not confirm');

                        setTimeout(() => {
                            window.location.href = '/wait-confirm-device';
                        }, 2000);
                    }
                })
                .addCase(rejected, (state, action) => {
                    console.log("login", action.error.message);
                    Toast('error', action.error.message.startsWith('Internal') ? "Somthing Wrong!" : action.error.message, 'tr', false, false, false, 6000, false);
                    sessionStorage.setItem('init-btn', 0);
                    setTimeout(() => {
                        sessionStorage.removeItem('init-btn');
                        // window.location.reload();
                    }, 1800);
                })
        };

        function setCategories() {
            var { pending, fulfilled, rejected } = extraActions.set_categories;
            builder
                .addCase(pending, (state) => {
                    state.error = null;
                })
                .addCase(fulfilled, (state, action) => {
                    const data = action.payload;
                    state.categories = data;

                })
                .addCase(rejected, (state, action) => {
                    console.log("login", action.error.message);
                    // Toast('error', action.error.message.startsWith('Internal') ? "Somthing Wrong!" : action.error.message, 'tr', false, false, false, 6000, false);

                })
        };



    }
}
